import React from 'react';
import { FaPlus } from 'react-icons/fa';

const AddTopicButton = ({ onClick, disabled, className }) => {
  return (
    <button
      onClick={onClick}
      className={`
        bg-cranberry-700 text-white 
        px-3 sm:px-4 py-1.5 
        rounded-xl 
        border-2 border-neutral-900
        hover:bg-cranberry-600 
        transition-colors duration-300 
        font-medium 
        text-sm sm:text-base 
        flex items-center justify-center
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''} 
        ${className}
      `}
      disabled={disabled}
    >
      <FaPlus className="mr-1.5 sm:mr-2 w-3.5 h-3.5 sm:w-4 sm:h-4" />
      Add Topic
    </button>
  );
};

export default AddTopicButton;
